import Mask from "../presentation/components/form/formik/input-mask/utils/mask";

/**
 * Aplica uma máscara a uma string de entrada
 * @param value - String de entrada (apenas números ou caracteres)
 * @param mask - Array de RegExp e strings definindo a máscara
 * @returns String formatada com a máscara aplicada
 */
export const applyMask = (
  value: string,
  mask: (string | RegExp)[]
): string => {
  if (!value || !mask || mask.length === 0) {
    return value || "";
  }

  // Remove todos os caracteres que não sejam alfanuméricos
  const cleanValue = value.replace(/[^a-zA-Z0-9@._-]/g, "");

  let maskedValue = "";
  let valueIndex = 0;

  for (let i = 0; i < mask.length && valueIndex < cleanValue.length; i += 1) {
    const maskChar = mask[i];

    if (typeof maskChar === "string") {
      // Se o caractere da máscara é uma string literal, adiciona diretamente
      maskedValue += maskChar;
    } else if (maskChar instanceof RegExp) {
      // Se é uma RegExp, tenta aplicar ao próximo caractere do valor
      const currentChar = cleanValue[valueIndex];

      if (maskChar.test(currentChar)) {
        maskedValue += currentChar;
        valueIndex += 1;
      } else {
        // Se o caractere não passa no teste da regex, para o processamento
        break;
      }
    }
  }

  return maskedValue;
};

/**
 * Aplica uma máscara baseada no nome da máscara predefinida
 * @param value - String de entrada
 * @param maskName - Nome da máscara (CPF, CNPJ, CEP, etc.)
 * @returns String formatada
 */
export const applyNamedMask = (value: string, maskName: string): string => {
  const getMask = (name: string): (string | RegExp)[] | null => {
    const result = Mask(name);
    return result;
  };

  const mask = getMask(maskName);
  if (!mask) {
    return value;
  }

  const clean = value.replace(/[^0-9]/g, "");

  return applyMask(clean, mask);
};
